import React, { useEffect } from 'react';
import { EndMillsCategoryContent } from '../components/EndMillsCategoryContent';
import { SiteLayout } from '../components/SiteLayout';
export function CategoryTemplatePage() {
  useEffect(() => {
    document.title = 'End Mills & End Milling Cutters | Milling Bits | 6G Tools.';
  }, []);
  return <SiteLayout data-id="element-776" data-mp="26btczb0klyno"><EndMillsCategoryContent data-id="element-777" data-mp="26ba38hl2qgkq" /></SiteLayout>;
}